import React, { useRef, useState } from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { checkmarkOutline, closeOutline, trashOutline } from "ionicons/icons";

type DeleteConfirmButtonProps = {
  onConfirm: () => void;
  disabled?: boolean;
};

const DeleteConfirmButton: React.FC<DeleteConfirmButtonProps> = ({ onConfirm, disabled }) => {
  const [confirming, setConfirming] = useState(false);
  const containerRef = useRef<HTMLSpanElement>(null);

  const handleBlur = (event: React.FocusEvent<HTMLSpanElement>) => {
    const nextTarget = event.relatedTarget as Node | null;
    if (!containerRef.current?.contains(nextTarget)) {
      setConfirming(false);
    }
  };

  return (
    <span
      ref={containerRef}
      onBlur={handleBlur}
      tabIndex={-1}
      style={{ margin: "0 1em", display: "inline-flex", gap: "0.25em" }}
    >
      {confirming ? (
        <>
          <IonButton
            color="danger"
            onClick={() => {
              setConfirming(false);
              onConfirm();
            }}
            disabled={disabled}
          >
            <IonIcon icon={checkmarkOutline} />
          </IonButton>
          <IonButton
            onClick={() => setConfirming(false)}
            disabled={disabled}
          >
            <IonIcon icon={closeOutline} />
          </IonButton>
        </>
      ) : (
        <IonButton
          color="danger"
          onClick={() => setConfirming(true)}
          disabled={disabled}
        >
          <IonIcon icon={trashOutline} />
        </IonButton>
      )}
    </span>
  );
};

export default DeleteConfirmButton;
